import get from 'lodash/get';
import ContentItemWithResolver from "models/ContentItemWithResolver";

export default class CaseStudiesLawTranslation extends ContentItemWithResolver {
	get translation(): string {
		return get(this, '_translation.value', '');
	}

	get caseStudiesLawCodeName(): string {
		return get(this, '_case_studies_sections.taxonomyTerms[0].codename', '');
	}
}
